import { tableFieldConvert } from '@/configs/tableConfigs';
import { TSelectedFilterValues } from '@/components/table/types';
import { getUrlSearchParamsString } from '@/helpers/urlParamsHelpers';

export type TReportBuilderData = {
  date: Array<string>;
  perPage: number;
  page: number;
  sort: string;
  filters: TSelectedFilterValues;
  dimensions: TSelectedFilterValues;
  metrics: TSelectedFilterValues;
};

export const getReportBuilderRequestData = (
  data: TReportBuilderData
): string => {
  const urlSearchParams: URLSearchParams = new URLSearchParams();

  try {
    const { date, perPage, page, sort, filters, dimensions, metrics } = data;

    if (date?.length) {
      const [fromDate, toDate] = date;
      urlSearchParams.append(tableFieldConvert('fromDate'), fromDate);
      urlSearchParams.append(tableFieldConvert('toDate'), toDate);
    }

    if (perPage) {
      urlSearchParams.append(tableFieldConvert('perPage'), String(perPage));
    }

    if (page) {
      urlSearchParams.append(tableFieldConvert('page'), String(page));
    }

    if (sort) {
      urlSearchParams.append(tableFieldConvert('sort'), sort);
    }

    if (filters?.length) {
      for (const item of filters) {
        urlSearchParams.append(
          tableFieldConvert('filters') + `[${item.field}][]`,
          String(item.value)
        );
      }
    }

    if (dimensions?.length) {
      for (const item of dimensions) {
        urlSearchParams.append(
          tableFieldConvert('dimensions'),
          String(item.value)
        );
      }
    }

    if (metrics?.length) {
      for (const item of metrics) {
        urlSearchParams.append(
          tableFieldConvert('metrics') + '[]',
          String(item.value)
        );
      }
    }
  } catch (err) {
    console.error('getReportBuilderRequestData: ', err);
  }

  return getUrlSearchParamsString(urlSearchParams);
};
